/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Setpoint_Input_Mode_Dead_BandInputs */



/**
* | output |
* | --- |
* | "By dead band" |
*
* @param {Air_Handler_Unit_Setpoint_Input_Mode_Dead_BandInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_setpoint_input_mode_dead_band = /** @type {((inputs?: Air_Handler_Unit_Setpoint_Input_Mode_Dead_BandInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Setpoint_Input_Mode_Dead_BandInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("By dead band")
	return /** @type {LocalizedString} */ ("Par bande morte")
});